<template>
  <div>
    <Page
      :fetch-data="items"
      :fields="[
        {
          key: 'id',
          label: 'Pedido',
        },
        {
          key: 'customer_name',
          label: 'Cliente',
        },
        {
          key: 'created_at',
          label: 'Data da Transação',
        },
        {
          key: 'status',
          label: 'Status',
        },
        {
          key: 'value',
          label: 'Valor',
        },
      ]"
    />
  </div>
</template>

<script>
import Page from './components/Page.vue'

import { getMercuryBankslips } from '@/service/integration'
import { callLoading } from '@/service/utilities/utilities'

export default {
  components: {
    Page,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>

</style>
